module.exports = "https://static.wmbcdn.com/uniweb/images/1405d7b787ebe395d91b3b5ec98963de.svg";